import Image from 'next/image';
import { BadgeDollarSign, Bot, Cable, Code2, Network, Plus, Zap } from 'lucide-react';

const partnershipStrengths = [
  {
    icon: BadgeDollarSign,
    label: 'Inteligência Comercial',
  },
  {
    icon: Code2,
    label: 'Arquitetura de Software',
  },
  {
    icon: Bot,
    label: 'Agentes Autônomos',
  },
  {
    icon: Cable,
    label: 'Integração Nativa com seu CRM',
  },
  {
    icon: Network,
    label: 'Ecossistema de APIs Customizadas',
  },
  {
    icon: Zap,
    label: 'Fricção Zero na Implementação',
  },
];

export default function StrategicPartnershipSection() {
  return (
    <section className="w-full bg-[#02020c] py-[28px] sm:py-[42px] lg:py-[56px] px-[14px] sm:px-[21px] lg:px-[28px]">
      <div className="w-full max-w-7xl mx-auto">
        <div className="relative overflow-hidden rounded-[32px] sm:rounded-[48px] lg:rounded-[64px] border border-[#ffffff1a] bg-[linear-gradient(180deg,rgba(255,255,255,0.10)_0%,rgba(255,255,255,0.03)_100%)] px-[20px] sm:px-[42px] lg:px-[64px] py-[28px] sm:py-[42px] lg:py-[56px]">
          <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(12,47,59,0.45),transparent_42%),radial-gradient(circle_at_bottom_right,rgba(60,60,206,0.18),transparent_32%)]" />
          <div className="relative flex flex-col gap-[28px] sm:gap-[42px] lg:grid lg:grid-cols-[minmax(0,1.1fr)_minmax(320px,0.9fr)] lg:items-center">
            <div className="flex flex-col items-start">
              <span
                className="rounded-full border border-[#ffffff1f] bg-[#0d2f3b33] px-[12px] py-[7px] text-[10px] sm:text-[12px] lg:text-[14px] font-medium leading-[12px] sm:leading-[14px] lg:leading-[17px] text-[#d7e8ff]"
                style={{ fontFamily: 'Raleway' }}
              >
                Parceria Estratégica
              </span>

              <h2
                className="mt-[14px] text-[25px] sm:text-[37px] lg:text-[50px] font-normal leading-[30px] sm:leading-[44px] lg:leading-[58px] text-left"
                style={{ fontFamily: 'Raleway' }}
              >
                <span className="bg-gradient-to-b from-[#f7faff] to-[#9eb5dc] bg-clip-text text-transparent">
                  Uma Aliança de Engenharia:
                </span>
                <span className="text-[#ffffff] font-semibold"> Evolutta + IaSolution</span>
              </h2>

              <p
                className="mt-[14px] text-[13px] sm:text-[17px] lg:text-[22px] font-normal leading-[19px] sm:leading-[26px] lg:leading-[32px] text-[#b7c3d7]"
                style={{ fontFamily: 'Raleway' }}
              >
                Agora entregamos soluções que escalam globalmente, nossas operações agora são integradas. Ao contratar a Evolutta, você conta com o suporte técnico e a robustez de duas casas de tecnologia focadas em um único objetivo: o seu lucro.
              </p>

              <div className="mt-[22px] flex flex-wrap gap-[10px] sm:gap-[12px] lg:gap-[14px]">
                {partnershipStrengths.map(({ icon: Icon, label }) => (
                  <div
                    key={label}
                    className="flex items-center gap-[10px] rounded-full border border-[#ffffff1a] bg-[#0b111dcc] px-[14px] py-[10px] shadow-[0_12px_32px_rgba(0,0,0,0.18)] backdrop-blur-sm"
                  >
                    <div className="flex h-[32px] w-[32px] items-center justify-center rounded-full bg-[linear-gradient(135deg,rgba(12,47,59,0.95)_0%,rgba(96,165,250,0.35)_100%)] text-[#dff6ff]">
                      <Icon className="h-[16px] w-[16px]" strokeWidth={1.8} />
                    </div>
                    <span
                      className="text-[11px] sm:text-[12px] lg:text-[14px] font-medium leading-[14px] sm:leading-[15px] lg:leading-[18px] text-[#eff6ff]"
                      style={{ fontFamily: 'Raleway' }}
                    >
                      {label}
                    </span>
                  </div>
                ))}
              </div>

              <p
                className="mt-[14px] max-w-[760px] text-[12px] sm:text-[15px] lg:text-[18px] font-normal leading-[18px] sm:leading-[22px] lg:leading-[27px] text-[#9fb3cf]"
                style={{ fontFamily: 'Raleway' }}
              >
                Nossa tecnologia se adapta às suas ferramentas (CRM, ERP, WhatsApp), não o contrário. Implementação sem mudanças de processo.
              </p>
            </div>

            <div className="relative">
              <div className="rounded-[28px] border border-[#ffffff14] bg-[#08111bcc] p-[18px] sm:p-[24px] lg:p-[28px] shadow-[0_18px_60px_rgba(0,0,0,0.28)] backdrop-blur-sm">
                <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-center gap-[10px] sm:gap-[14px] lg:gap-[18px]">
                  <div className="rounded-[24px] border border-[#ffffff17] bg-[linear-gradient(180deg,rgba(255,255,255,0.08)_0%,rgba(255,255,255,0.03)_100%)] px-[18px] py-[20px] sm:px-[24px] sm:py-[26px] text-center">
                    <div className="flex min-h-[96px] items-center justify-center">
                      <Image
                        src="/images/img_group_1707478726.svg"
                        alt="Evolutta"
                        width={136}
                        height={88}
                        className="h-[42px] w-auto sm:h-[52px] lg:h-[64px]"
                      />
                    </div>
                  </div>

                  <div className="flex h-[46px] w-[46px] items-center justify-center rounded-full border border-[#7dd3fc40] bg-[linear-gradient(135deg,rgba(13,47,59,0.95)_0%,rgba(59,130,246,0.35)_100%)] text-white shadow-[0_0_24px_rgba(14,165,233,0.25)]">
                    <Plus className="h-[18px] w-[18px]" strokeWidth={2.2} />
                  </div>

                  <div className="rounded-[24px] border border-[#ffffff17] bg-[linear-gradient(180deg,rgba(255,255,255,0.08)_0%,rgba(255,255,255,0.03)_100%)] px-[18px] py-[20px] sm:px-[24px] sm:py-[26px] text-center">
                    <div className="flex min-h-[96px] flex-col items-center justify-center">
                      <span
                        className="bg-gradient-to-r from-[#f7faff] via-[#9ed8ff] to-[#b1c5ff] bg-clip-text text-[24px] sm:text-[28px] lg:text-[34px] font-semibold leading-[28px] sm:leading-[34px] lg:leading-[40px] text-transparent"
                        style={{ fontFamily: 'Raleway' }}
                      >
                        IaSolution
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-[16px] rounded-[22px] border border-[#ffffff12] bg-[#0d1522cc] px-[16px] py-[14px] text-center">
                  <span
                    className="text-[11px] sm:text-[13px] lg:text-[15px] font-normal leading-[14px] sm:leading-[17px] lg:leading-[20px] text-[#dbe7f6]"
                    style={{ fontFamily: 'Raleway' }}
                  >
                    Duas casas de tecnologia, uma única operação orientada a escala, performance e lucro.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
